var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-skin" }, [
    _c(
      "div",
      {
        staticClass: "navbar navbar-default ace-save-state",
        class: { "red-background": _vm.checkEnv() },
        attrs: { id: "navbar" }
      },
      [
        _c(
          "div",
          {
            staticClass: "navbar-container ace-save-state",
            attrs: { id: "navbar-container" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-header pull-left" }, [
              _c("a", { staticClass: "navbar-brand", attrs: { href: "/" } }, [
                _c("img", { attrs: { src: _vm.logo, alt: "logo" } })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navbar-buttons navbar-header pull-right",
                attrs: { role: "navigation" }
              },
              [
                _c("ul", { staticClass: "nav ace-nav" }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle",
                        attrs: { "data-toggle": "dropdown", href: "#" }
                      },
                      [
                        _vm.error
                          ? _c("i", {
                              staticClass:
                                "menu-icon fa fa-user custom-acount-icon"
                            })
                          : _c("img", {
                              staticClass: "nav-user-photo",
                              attrs: {
                                id: "avatar-menu-top",
                                src: "",
                                alt: "avatar"
                              }
                            }),
                        _vm._v(" "),
                        _c("span", { staticClass: "user-info" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.profile.userName) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "ace-icon fa fa-caret-down" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "user-menu dropdown-menu-right dropdown-menu dropdown-yellow dropdown-caret dropdown-close"
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              tag: "li",
                              to: { name: "userchangepassword" }
                            }
                          },
                          [_c("a", [_vm._v("パスワード変更")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              tag: "li",
                              to: { name: "user-configuration" }
                            }
                          },
                          [_c("a", [_vm._v("設定")])]
                        ),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.logout()
                                }
                              }
                            },
                            [_vm._v("サインアウト")]
                          )
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(2)
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "main-container ace-save-state",
        attrs: { id: "main-container" }
      },
      [
        _c(
          "div",
          {
            staticClass: "sidebar responsive ace-save-state",
            attrs: { id: "sidebar" }
          },
          [
            _c(
              "ul",
              { staticClass: "nav nav-list" },
              [
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "dashboard" } } },
                  [
                    _c("a", { attrs: { id: "sideDashboardLink" } }, [
                      _c("i", { staticClass: "menu-icon fa fa-tachometer" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("メインメニュー")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "process-user-register" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideExcelsLink" } }, [
                          _c("i", { staticClass: "menu-icon fa fa-share-alt" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("ユーザー一括登録")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "user" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideUsersLink" } }, [
                          _c("i", { staticClass: "menu-icon fa fa-user" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("ユーザー")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "gates" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideGatesLink" } }, [
                          _c("i", {
                            staticClass: "menu-icon glyphicon glyphicon-log-in"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("ゲート")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "group" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideGroupsLink" } }, [
                          _c("i", { staticClass: "menu-icon fa fa-users" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("ゲートグループ")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "pcode" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sidePcodeLink" } }, [
                          _c("i", {
                            staticClass: "menu-icon fa fa-credit-card "
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("個人コード")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "phones" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sidePhonesLink" } }, [
                          _c("i", {
                            staticClass: "menu-icon glyphicon glyphicon-phone"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("スマートフォン")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      tag: "li",
                      to: { name: "logs" },
                      "active-class": "active"
                    }
                  },
                  [
                    _c("a", { attrs: { id: "sideLogsLink" } }, [
                      _c("i", {
                        staticClass: "menu-icon glyphicon glyphicon-list"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("ログ情報")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "setting" },
                          "active-class": "active"
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.goSetting($event)
                          }
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideSettingLink" } }, [
                          _c("i", {
                            staticClass: "menu-icon glyphicon glyphicon-cog"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("システム設定")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "keyadd" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideKeyaddLink" } }, [
                          _c("i", {
                            staticClass: "menu-icon glyphicon glyphicon-check"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("鍵共有")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAdmin === "true"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "li",
                          to: { name: "export" },
                          "active-class": "active"
                        }
                      },
                      [
                        _c("a", { attrs: { id: "sideExportLink" } }, [
                          _c("i", { staticClass: "menu-icon fa fa-share" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("CSVエクスポート")
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3)
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "main-content-inner" },
            [_c("router-view")],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "footer-inner" }, [
            _c("div", { staticClass: "footer-content" }, [
              _c("span", { staticClass: "bigger-120" }, [
                _c("span", { staticClass: "blue bolder" }, [
                  _vm._v(_vm._s(_vm.corporateName))
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: { id: "my-modal-profile", tabindex: "-1" }
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.error
                    ? _c("div", { staticClass: "alert alert-danger" }, [
                        _vm._v(
                          "\n            " + _vm._s(_vm.error) + "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "user-profile row",
                      attrs: { id: "user-profile-1" }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "profile-user-info profile-user-info-striped"
                          },
                          [
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "profile-info-name" }, [
                                _vm._v("事業者ID:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-click",
                                    attrs: { id: "ownerid" }
                                  },
                                  [_vm._v(_vm._s(_vm.profile.ownerId))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "profile-info-name" }, [
                                _vm._v("ユーザーID:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-click",
                                    attrs: { id: "userid" }
                                  },
                                  [_vm._v(_vm._s(_vm.profile.userId))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "profile-info-name" }, [
                                _vm._v("ユーザー名:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-click",
                                    attrs: { id: "kanji" }
                                  },
                                  [_vm._v(_vm._s(_vm.profile.userName))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "profile-info-name" }, [
                                _vm._v("ふりがな:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-click",
                                    attrs: { id: "furigana" }
                                  },
                                  [_vm._v(_vm._s(_vm.profile.furigana))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-info-row" }, [
                              _c("div", { staticClass: "profile-info-name" }, [
                                _vm._v("メールアドレス:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-value" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-click",
                                    attrs: { id: "email" }
                                  },
                                  [_vm._v(_vm._s(_vm.profile.email))]
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(7)
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggle menu-toggler pull-left",
        attrs: { type: "button", id: "menu-toggler", "data-target": "#sidebar" }
      },
      [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle sidebar")]),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "#my-modal-profile", "data-toggle": "modal" } },
        [_vm._v("プロフィール")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pull-right" }, [
      _c(
        "a",
        {
          staticClass: "btn-cusstom pull-right btn-support",
          attrs: { href: "https://support.alligate.me/hc/ja", target: "_blank" }
        },
        [
          _c("i", { staticClass: "fa fa-question-circle" }),
          _vm._v(" "),
          _c("br"),
          _vm._v("ヘルプ")
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "sidebar-toggle sidebar-collapse",
        attrs: { id: "sidebar-collapse" }
      },
      [
        _c("i", {
          staticClass: "ace-icon fa fa-angle-double-left ace-save-state",
          attrs: {
            id: "sidebar-toggle-icon",
            "data-icon1": "ace-icon fa fa-angle-double-left",
            "data-icon2": "ace-icon fa fa-angle-double-right"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn-scroll-up btn btn-sm btn-inverse",
        attrs: { href: "#", id: "btn-scroll-up" }
      },
      [
        _c("i", {
          staticClass: "ace-icon fa fa-angle-double-up icon-only bigger-110"
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("プロフィール")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-4 center" }, [
      _c("span", { staticClass: "profile-picture" }, [
        _c("img", {
          staticClass: "editable img-responsive",
          attrs: { id: "avatar", alt: "User's Avatar", src: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-danger pull-right",
          attrs: { "data-dismiss": "modal" }
        },
        [_vm._v("\n            閉じる\n          ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-005bfc5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005bfc5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = null
// module chunks = 